export { useLoyaltyRedeemPromoCodeMutation } from '@fhs-legacy/frontend/src/generated/graphql-gateway';
import { useIntl } from 'react-intl';

import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { useLoyaltyContext } from '@fhs-legacy/frontend/src/state/loyalty';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';

export function useLoyaltyLegacyStates() {
  const intl = useIntl();
  const { store } = useStoreContext();
  const { serviceMode } = useServiceModeContext();
  const { loyaltyUser, loyaltyUserReady, loading: loyaltyUserLoading } = useLoyaltyContext();
  const loyaltyId = loyaltyUser?.id;
  const loyaltyUserExpireDateFormattedText = useAppSelector(
    selectors.loyalty.createLoyaltyUserExpireDateFormattedTextSelector(intl)
  );
  const selectedOffer = useAppSelector(selectors.loyalty.selectSelectedOffer);
  const { isAuthenticated } = useAuthContext();
  return {
    store,
    serviceMode,
    loyaltyUserReady,
    loyaltyId,
    loyaltyUser,
    loyaltyUserLoading,
    loyaltyUserExpireDateFormattedText,
    selectedOffer,
    isAuthenticated,
  };
}
